module.exports = __webpack_public_path__ + "img/TMB.0cee449c.png";